export const ROUTES = {
	LOGIN: 'login',
	LOGAS: 'logas',
	FORGOTPASSWORD: 'forgot-password',
	RESETPASSWORD: 'reset-password',
	INVITATION: 'invitation',
	ACTIVE_PROPOSAL_RESPONSE: 'active-proposal-response',
	TALENTPLUG_RETURN: 'talentplug-return',
	APP: {
		_ROOT: 'app',
		HOME: 'home',
		NOTIFICATIONS: 'notifications',
		PROFILE: {
			_ROOT: 'profile',
			INFOS: 'profile.infos',
			NOTIFICATIONS: 'profile.notifications',
			PASSWORD: 'profile.password',
		},
		AGENCYPROFILE: 'agencyProfile',
		WORKERS: {
			_ROOT: 'app.interims._root',
			LIST: 'app.interims.list',
			PLANNING: 'app.interims.planning',
			REGISTRATIONS: 'app.interims.registrations',
			PROFIL: {
				_ROOT: 'app.workers.profil._root',
				CAREER: 'app.workers.profil.career',
				ADMIN: 'app.workers.profil.admin',
				SUIVI: 'app.workers.profil.suivi',
				INTERIM_DOCUMENTS: 'app.workers.profil.interim-documents',
				INTERIM_JOBOFFERS: 'app.workers.profil.interim-joboffers',
				INTERIM_SCHEDULE: 'app.workers.profil.interim-schedule',
				INTERIM_REVIEWS: 'app.workers.profil.interim-reviews',
				INTERIM_PROPOSITIONS: 'app.workers.profil.interim-propositions',
				INTERIM_MISSIONS: 'app.workers.profil.interim-missions',
				PAYMENT_REQUESTS: 'app.workers.profil.payment-requests',
			},
		},
		CLIENTS: 'clients',
		CLIENT: {
			_ROOT: 'app.client._root',
			INFORMATIONS: 'app.client.general.informations',
			CONTACTS: 'app.client.general.contacts',
			ADDRESSES: 'app.client.general.addresses',
			COMPANY_NEEDS: 'app.client.general.company-needs',
			ORDER: 'app.client.order',
			PROPOSITIONS: 'app.client.propositions',
			REVIEWS: 'app.client.reviews',
		},
		COMPANY_NEED: {
			_ROOT: 'app.companyNeed._root',
			LIST: 'app.companyNeed.list',
			ARCHIVED_LIST: 'app.companyNeed.archived-list',
			MISSIONS: 'app.companyNeed.missions',
			JOB_OFFERS: 'app.companyNeed.job-offers',
			DETAIL: {
				_ROOT: 'app.companyNeed.detail._root',
				MATCHING: 'app.companyNeed.detail.matching',
				CANDIDATES: 'app.companyNeed.detail.candidates',
				POOL: 'app.companyNeed.detail.pool',
				RECRUITMENT: 'app.companyNeed.detail.recruitment',
				MISSIONS: 'app.companyNeed.detail.missions',
				REJECTED_PROFILES: 'app.companyNeed.detail.rejectedProfiles',
			},
		},
		ACTIVE_PROPOSITION: {
			_ROOT: 'app.activeProposition._root',
			PROPOSITIONS: 'app.activeProposition.propositions',
			COMPANY_NEED_PROPOSITIONS:
				'app.activeProposition.company-need-propositions',
			COMPANIES: 'app.activeProposition.companies',
			SEND: 'app.activeProposition.send',
		},
		PAYMENT_REQUEST: {
			_ROOT: 'app.paymentRequest._root',
			LIST: 'app.paymentRequest.list',
			ARCHIVE: 'app.paymentRequest.archive',
		},
	},
};
